export const publicationsRouteNames = {
  MyPublicationsRoute: 'MyPublicationsRoute',
  MyEditRequests: 'MyPublicationsEditRequests',
  PublicationsListRoute: 'PublicationsListRoute',
  PublicationRoute: 'PublicationRoute',
  PublicationHistoryRoute: 'PublicationHistoryRoute'
}
const rn = publicationsRouteNames

export const publicationsRouteURLs = {
  [rn.MyPublicationsRoute]: '/publications/own',
  [rn.MyEditRequests]: '/publications/edit-requests',
  [rn.PublicationsListRoute]: '/publications/all',
  [rn.PublicationRoute]: '/publications/:id',
  [rn.PublicationHistoryRoute]: '/publications/:id/history'
}

export const publicationsPages = [
  {
    path: publicationsRouteURLs[rn.MyPublicationsRoute],
    name: rn.MyPublicationsRoute,
    meta: {
      sidebar: {
        icon: ['fa', 'address-card'],
        isDisplay: true
      },
      navbar: {
        group: 'Публикации',
        displayName: 'Мои публикации'
      }
    },
    component: () =>
      import(
        /* webpackChunkName: "MyPublicationsRoute" */ '@/views/publications/MyPublicationsRoute.vue'
      )
  },

  {
    path: publicationsRouteURLs[rn.MyEditRequests],
    name: rn.MyEditRequests,
    meta: {
      sidebar: {
        icon: ['fa', 'edit'],
        isDisplay: true
      },
      navbar: {
        group: 'Публикации',
        displayName: 'Мои заявки на редактирование'
      }
    },
    component: () =>
      import(
        /* webpackChunkName: "MyEditRequestsRoute" */ '@/views/publications/MyEditRequestsRoute.vue'
      )
  },

  {
    path: publicationsRouteURLs[rn.PublicationsListRoute],
    name: rn.PublicationsListRoute,
    meta: {
      sidebar: {
        icon: ['fa', 'newspaper'],
        isDisplay: true
      },
      navbar: {
        group: 'Публикации',
        displayName: 'Все публикации'
      }
    },
    component: () =>
      import(
        /* webpackChunkName: "PublicationsListRoute" */ '@/views/publications/PublicationsListRoute.vue'
      )
  },

  {
    path: publicationsRouteURLs[rn.PublicationRoute],
    name: rn.PublicationRoute,
    meta: {
      sidebar: null,
      navbar: {
        group: 'Публикации',
        displayName: 'Публикация'
      }
    },
    component: () =>
      import(
        /* webpackChunkName: "PublicationRoute" */ '@/views/publications/PublicationRoute.vue'
      )
  },

  {
    path: publicationsRouteURLs[rn.PublicationHistoryRoute],
    name: rn.PublicationHistoryRoute,
    meta: {
      sidebar: null,
      navbar: {
        group: 'Публикации',
        displayName: 'История публикации'
      }
    },
    component: () =>
      import(
        /* webpackChunkName: "PublicationHistoryRoute" */ '@/views/publications/PublicationHistoryRoute.vue'
      )
  }
]
